module.exports = __webpack_public_path__ + "media/components/images/logo_blue-9b9385dc3073750498743d1bf8fed738.png";